import { createAction } from '@reduxjs/toolkit';

export const getActiveAnnouncements = {
    request: createAction('announcement/getActive/request'),
    success: createAction('announcement/getActive/success'),
    failed: createAction('announcement/getActive/failed'),
};

export const dismissAnnouncement = {
    request: createAction('announcement/dismiss/request'),
    success: createAction('announcement/dismiss/success'),
    failed: createAction('announcement/dismiss/failed'),
};
